/*
  Allows consumers to use the decimal prop, but shorten strings that look like
  floats into an integer if they have all "0" decimals.

  It does not change numbers with at least one non-zero character. For example,
  it would not change anything about "123.00100", but it would change
  "123.000000" to "123".
*/
import { IF_ALL_DECIMAL_ZEROS } from "../constants.js";
var checkForAllDecimalZeros = (decimals, ifAllDecimalZeros, formattedValue) => {
  // separate integer and decimal sides
  var [integerSide] = formattedValue.split('.');
  var [, decimalSide] = formattedValue.split('.');

  /* if the consumer didn't use the decimals option, care about shortening whole
  float zeros, or the formatted number didn't have decimals we can stop now */
  if (decimals === 0 || ifAllDecimalZeros === IF_ALL_DECIMAL_ZEROS.FLOAT || !decimalSide) return formattedValue;

  /* if the the consumer is using compact prop and/or percent format the last
    two characters could be a letter or percent sign, we store both or empty
    strings for later */
  var secondToLastCharacter = decimalSide.length >= 2 && /[A-z]/.test(decimalSide[decimalSide.length - 2]) ? decimalSide[decimalSide.length - 2] : '';
  var lastCharacter = /[A-z, %]/.test(decimalSide[decimalSide.length - 1]) ? decimalSide[decimalSide.length - 1] : '';

  // slice two or one non-number characters off decimal side if present
  if (secondToLastCharacter !== '') {
    decimalSide = decimalSide.slice(0, decimalSide.length - 2);
  } else if (lastCharacter !== '') {
    decimalSide = decimalSide.slice(0, decimalSide.length - 1);
  }

  // if each character of decimal half is 0, mutate to empty string
  if (Array.from(decimalSide).every(char => char === '0')) decimalSide = '';

  // put everything back together
  return "".concat(integerSide).concat(decimalSide ? '.' : '').concat(decimalSide).concat(secondToLastCharacter).concat(lastCharacter);
};
export default checkForAllDecimalZeros;